import BwicContainer from './BwicContainer';
import Bwic from './Bwic';

export default BwicContainer;
export { Bwic };
